/**
 *  抢修统计
 */
import * as HttpService from "../../../../service/HttpService";

/**
 *  按工单状态统计百分比
 */
export const getWorkStatisticsOfRepair = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/workOrderOvw/getWorkStatisticsOfRepair",params);
};

/**
 *  按抢修信息来源统计百分比
 */
export const getRepairWorkOfResource = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/workOrderOvw/getRepairWorkOfResource",params);
};

/**
 *  查询抢修完成率统计
 */
export const getRepairStatusIsFiled = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/workOrderOvw/getRepairStatusIsFiled",params);
};

/**
 *  查询抢修分布曲线图数据
 */
export const getRepairDistribution = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/workOrderOvw/getRepairDistribution",params);
};
